import DatePicker from './CheckboxDatePicker';
import { NotesComponent } from './NotesComponent';
import { StatusComponent } from './StatusComponent';
import { Actions } from './Actions';
import { getTableRow } from './styles';
import { ListVehiclePoolRowFromServer, ListVehiclePoolStatus } from './types';
import {
  useDeletePoolMutation,
  useDuplicatePoolMutation,
  useSubmitPoolMutation
} from '../../../../services/api/list-vehicles';
import { SellerRequests } from './SellerRequests';
import { useDispatch } from 'react-redux';
import api from 'services/api/list-vehicles';
import { ScheduleIcon } from '../../../Icons/ScheduleIcon';
import styled from 'styled-components';
import { SchedulePool } from './SchedulePool';

const TableRow = getTableRow('div');

type Action = 'duplicateAction' | 'editAction' | 'submitAction' | 'deleteAction';

const getActionsByStatus = (status: string): Action[] => {
  if (status === ListVehiclePoolStatus.Submitted) {
    return ['duplicateAction', 'editAction', 'deleteAction'];
  }

  if (status === ListVehiclePoolStatus.NewListing) {
    return ['duplicateAction', 'editAction', 'deleteAction', 'submitAction'];
  }

  if (status === ListVehiclePoolStatus.Done) {
    return [];
  }

  return [];
};

export const ListVehiclesRow = ({ item }: { item: ListVehiclePoolRowFromServer }) => {
  const [deletePool] = useDeletePoolMutation();
  const [submitPool] = useSubmitPoolMutation();
  const [duplicatePool] = useDuplicatePoolMutation();
  const dispatch = useDispatch<any>();

  const actionsMap: Record<Action, () => any> = {
    duplicateAction: () => duplicatePool(item.id),
    deleteAction: () => deletePool(item.id),
    submitAction: () => submitPool(item.id),
    editAction: () => {
      dispatch(
        api.util.updateQueryData('getVehiclesPools', undefined, draft => {
          const curr = draft.find(e => e.id === item.id);
          if (!curr) {
            return;
          }

          curr.actionStatus = 'editing';
        })
      );
    }
  };

  const actionProps = getActionsByStatus(item.status).reduce((acc, curr) => {
    return {
      ...acc,
      [curr]: actionsMap[curr]
    };
  }, {} as Record<Action, () => any>);

  return (
    <TableRow>
      <SchedulePool item={item} />
      <span>{item.lister?.first_name}</span>
      <SellerRequests item={item} />

      <DatePicker value={item.seller_preferable_date} />
      <NotesComponent poolId={item.id} />
      <DatePicker value={item.preferable_date} />
      <StatusComponent status={item.status} />
      <Actions {...actionProps} />
    </TableRow>
  );
};
